var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-input',{staticClass:"tech-map-input",attrs:{"filled":"","value":_setup.value,"placeholder":_setup.value || '-',"label-slot":false,"type":_vm.type},on:{"input":function($event){return _setup.onChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }